import { keyframes } from 'styled-components';

const Spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export default Spin;
